"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomColor = exports.randomIntFromInterval = exports.mockImageUrl = exports.mockVideoEncoding = exports.mockMediaConstraints = exports.mockDocument = exports.mockGuideEmbedObject = exports.mockGuideVideoObject = exports.mockGuideImage = exports.mockUploadingMediaItem = void 0;
var color_1 = __importDefault(require("color"));
var imageSerial = 1;
var idSerial = 1;
function mockUploadingMediaItem(tempId, step, progress, file) {
    if (progress === void 0) { progress = null; }
    return {
        tempId: tempId,
        type: 'Uploading',
        step: step,
        progress: progress,
        file: file ? new File([''], file.name) : undefined,
    };
}
exports.mockUploadingMediaItem = mockUploadingMediaItem;
function mockGuideImage(options) {
    if (options === void 0) { options = {}; }
    var width = randomIntFromInterval(100, 500);
    var height = randomIntFromInterval(100, 500);
    var imageUrl = mockImageUrl(width, height, "Image #".concat(imageSerial++));
    return __assign({ type: 'GuideImage', srcid: null, guid: '{guid}', imageid: idSerial++, ratio: 'VARIABLE', active: true, encoding: '{encoding}', mini: imageUrl, thumbnail: imageUrl, standard: imageUrl, medium: imageUrl, original: imageUrl, width: width, height: height, filename: '{FILENAME}', date: Date.now() / 1000, filter_state: true }, options);
}
exports.mockGuideImage = mockGuideImage;
var videoSerial = 1;
function mockGuideVideoObject(options) {
    if (options === void 0) { options = {}; }
    var width = randomIntFromInterval(100, 500);
    var height = randomIntFromInterval(100, 500);
    var imageUrl = mockImageUrl(width, height, "Video #".concat(videoSerial++));
    return __assign({ type: 'GuideVideoObject', srcid: null, guid: '{guid}', imageid: idSerial++, objectid: idSerial++, videoid: idSerial++, active: true, video_urls: {
            mp4_720: '{mp4_720}',
        }, mini: imageUrl, thumbnail: imageUrl, '140x105': imageUrl, '200x150': imageUrl, standard: imageUrl, '440x330': imageUrl, medium: imageUrl, large: imageUrl, huge: imageUrl, width: width, height: height, filename: '{filename}', date: Date.now() / 1000, filter_state: true }, options);
}
exports.mockGuideVideoObject = mockGuideVideoObject;
var embedSerial = 1;
function mockGuideEmbedObject(options) {
    if (options === void 0) { options = {}; }
    var width = randomIntFromInterval(100, 500);
    var height = randomIntFromInterval(100, 500);
    var imageUrl = mockImageUrl(width, height, "Embed #".concat(embedSerial++));
    return __assign({ type: 'GuideEmbedObject', imageid: idSerial++, objectid: idSerial++, embedid: idSerial++, mini: imageUrl, thumbnail: imageUrl, standard: imageUrl, medium: imageUrl, view_url: '{view_url}', width: width, height: height, html: '{html}', filename: '{filename}', provider: '{provider}', date: Date.now() / 1000, filter_state: true }, options);
}
exports.mockGuideEmbedObject = mockGuideEmbedObject;
var documentSerial = 1;
function mockDocument(options) {
    if (options === void 0) { options = {}; }
    var width = 850;
    var height = 1100;
    var imageUrl = mockImageUrl(width, height, "Document #".concat(documentSerial++));
    return __assign({ type: 'Document', guid: '{guid}', documentid: idSerial++, filename: '{filename}', title: '{title}', size: 100, thumbnailid: idSerial++, imageid: idSerial++, document_type: '{document_type}', document_extension: '{document_extension}', document_group: '{document_group}', standard: imageUrl, thumbnail: imageUrl, mini: '{mini}', edit_url: '{edit_url}', view_url: '{view_url}', date: Date.now() / 1000, filter_state: true }, options);
}
exports.mockDocument = mockDocument;
function mockMediaConstraints() {
    return {
        maxMediaSize: 1000,
        maxMediaLength: 1000,
        videosEnabled: true,
        videoEncodings: {
            MP4_592: mockVideoEncoding(),
            MP4_TS: mockVideoEncoding(),
            OGG: mockVideoEncoding(),
            WEBM: mockVideoEncoding(),
        },
        markerColors: ['red', 'green'],
        defaultMarkerColor: 'red',
        locationName: undefined,
        filetypes: ['png', 'jpg'],
    };
}
exports.mockMediaConstraints = mockMediaConstraints;
function mockVideoEncoding() {
    return {
        column: 'MP4_592',
        label: 'string',
        encoding: 'string',
        width: 100,
        height: 100,
        codecs: 'string',
        ffmpeg_args: 'string',
        mime: 'string',
        always_generate: true,
    };
}
exports.mockVideoEncoding = mockVideoEncoding;
function mockImageUrl(width, height, text) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    // Return a dummy string in test environments
    if (process.env.JEST_WORKER_ID !== undefined)
        return "{IMAGE URL}";
    // Return a randomly generated image in storybook
    var ctx = canvas.getContext('2d');
    if (!ctx)
        return "{IMAGE URL}";
    var color = new color_1.default(getRandomColor());
    ctx.fillStyle = color.mix(new color_1.default('white'), 0.75).hex();
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = color.mix(new color_1.default('black'), 0.7).hex();
    ctx.font = '50px Georgia';
    ctx.fillText("".concat(text), 5, 50);
    return canvas.toDataURL();
}
exports.mockImageUrl = mockImageUrl;
function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
exports.randomIntFromInterval = randomIntFromInterval;
function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
exports.getRandomColor = getRandomColor;
